module.exports = "/images/side-site-monitoring.svg?2bc444d7007373d08828e9ba90475f05";